import { useState } from "react";
import { useResetInputs } from "src/Contexts";
import { useContextComissoes } from "src/Contexts/comissoes/ComissoesContext";
import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { useLayoutMainContext } from "src/Contexts/MainLayoutContext";
import { UseAutoCompletedAll } from "src/Contexts/Utils/UseAutoCompletedAll";
import { api } from "src/shared/setup/API/api";

interface IUseFormSubmit {
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
}

export const UseFeaturesFormulario = ({ setOpenModal }: IUseFormSubmit) => {
  const { valuesInputsComissaoCorretora } = useContextComissoes();
  const { setAttTable, id, } = useConfigPageContext();
  const { handleGetAlert } = useLayoutMainContext();
  const { resetInputs } = useResetInputs();

  const [loading, setLoading] = useState(false);

  const {
    valueAutoCompAdministradora,
    valueAutoCompModalidade,
    valueAutoCompOperadora,
  } = UseAutoCompletedAll();

  const {
    vitalicio,
    name,
    date_vigencia,
    parc_1,
    parc_2,
    parc_3,
    parc_4,
    parc_5,
    parc_6,
    parc_7,
    parc_8,
    parc_9,
    parc_10,
    parc_11,
    parc_12,
  } = valuesInputsComissaoCorretora;

  const objComissao = {
    name,
    date_vigencia,
    vitalicio: vitalicio === "NONE" ? null : Number(vitalicio),
    code_operadora: Number(valueAutoCompOperadora.id),
    code_modalidade: Number(valueAutoCompModalidade.id),
    code_administradora: valueAutoCompAdministradora.id
      ? Number(valueAutoCompAdministradora.id)
      : null,

    numero_parcela: {
      parc_1,
      parc_2,
      parc_3,
      parc_4,
      parc_5,
      parc_6,
      parc_7,
      parc_8,
      parc_9,
      parc_10,
      parc_11,
      parc_12,
    },
  };

  const handleCreate = async (isNotClose?: boolean) => {
    if (!objComissao.code_operadora) return handleGetAlert({ message: `Escolha uma operadora !` });
    if (!objComissao.code_modalidade) return handleGetAlert({ message: `Escolha uma modalidade !` });
    if (!objComissao.date_vigencia) return handleGetAlert({ message: `Escolha uma data de vigência !` });

    setLoading(true);

    return api
      .post("/comissoes/corretora/create", { ...objComissao })
      .then((res) => {
        handleGetAlert({ message: res.data.message });
        setAttTable((item) => !item);
        setOpenModal(isNotClose ?? false);
        resetInputs();
      })
      .catch((error) =>
        handleGetAlert({ message: error.response.data.message })
      )
      .finally(() => setLoading(false));
  };

  const handleEdit = () => {
    if (!objComissao.code_operadora) return handleGetAlert({ message: `Escolha uma operadora !` });
    if (!objComissao.code_modalidade) return handleGetAlert({ message: `Escolha uma modalidade !` });
    if (!objComissao.date_vigencia) return handleGetAlert({ message: `Escolha uma data de vigência !` });

    setLoading(true);

    return api
      .put(`/comissoes/corretora/${id}`, { ...objComissao })
      .then((res) => {
        setAttTable((item) => !item);
        handleGetAlert({ message: res.data.message });
        setOpenModal(false);
      })
      .catch((error) =>
        handleGetAlert({ message: error.response.data.message })
      )
      .finally(() => setLoading(false));
  };

  const handleSubmit = (isNotClose?: boolean) => {
    if (id) {
      handleEdit();
    } else {
      handleCreate(isNotClose);
    }
  };

  return { handleSubmit, loading };
};
